import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { OfficeModel } from '../../../shared/models/abre-cuentas.model';
import { DocumentModel } from '../../../shared/models/document.model';
import { OccupationModel } from '../../../shared/models/occupation.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { DaliService } from '@dali/tagger-ng8';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';

/**
 * Summary  The component to Occupation view
 *
 * @file    This file define Occupation Component as class
 * @author  Alejandro Jimenez Mateus.
 * @since   2019-05-29
 */
@Component({
  selector: 'app-occupation-component',
  templateUrl: './occupation.component.html',
  styleUrls: ['./occupation.component.scss'],
})
export class OccupationComponent implements OnInit {
  occupations: any[];
  selectedOccupation: OccupationModel;
  documentInfo: DocumentModel;
  selectOccupation = false;
  dataClient: any;
  officeInfo: OfficeModel;
  currentPhaseKey: string;
  productsType = {
    ORD: 'LD',
    TCR: 'TC',
  };

  /**
   * Summary Constructor of the component.
   * Description Initialize services and Enum that is used in the Component
   * @param navigationService
   * @param CaptureService
   * @param abreCuentasService
   * @param latamItLoaderService
   */
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private captureService: CaptureService,
    private validationHelperService: ValidationHelperService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private taggingService: TaggingService,
    private headerService: HeaderService,
    private bioCatchService: BioCatchService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false);
    this.dataClient = this.abreCuentasService.getCustomerData();
    this.currentPhaseKey = String(this.navigationService.getCurrentPhase().key);
    this.selectedOccupation = this.abreCuentasService.getOccupationSelected();
    this.occupations = (this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST));
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.occupations = this.occupations.map(occupation => ({
      id: `radio-${occupation.name}`,
      label: occupation.name,
      value: JSON.stringify(occupation),
      checked: !!this.selectedOccupation && this.selectedOccupation.name === occupation.name,
    }));
    if (!!this.selectedOccupation.id) { return; }
    if (!this.abreCuentasService.getCustomerData()) { return; }
    this.selectedOccupation = this.occupations.find(occupation => (
      occupation.label === this.abreCuentasService.getCustomerData().basic.profession),
    );
    if (this.selectedOccupation === undefined) {
      this.selectedOccupation = new OccupationModel();
    } else {
      this.abreCuentasService.setOccupationSelected(this.selectedOccupation);
    }
  }

  /**
   * Summary Load in selectedOccupation, the selected item from Occupations List
   * @param occupationselect Object type-Occupation Model
   */
  activeOccupation(event: any) {
    const radio = this.occupations.find(e => e.value === event.value);
    if (!radio) { return; }
    this.selectedOccupation = JSON.parse(radio.value);
    this.abreCuentasService.setOccupationSelected(this.selectedOccupation);
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    this.taggingService.pageTagEventOccupation(this.selectedOccupation.name, tagPageName);
  }

  /**
   * Summary Send body Object with params by go to backend and get a response with code and data
   */
  next() {
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    const body = {
      occupation_id: this.selectedOccupation.id.toString(),
      ciiu: this.selectedOccupation.ciiu,
      document_id: this.documentInfo.document_number,
    };

    const parms = {
      main_activity_id: this.selectedOccupation.id,
      first_name: this.abreCuentasService.getDocumentInfo().firstname,
      first_surname: this.abreCuentasService.getDocumentInfo().primary_lastname,
      product_type: this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL
      ? BUSINESS_CONST.PRODUCT_FOR_INCOMES_NOM :
      BUSINESS_CONST.PRODUCT_TYPE_SAVINGS,
    };

    this.captureService.sendProspectOccupationWithBody(body, parms).then(
      (res: any) => {
        if (!res) { return; }
        let nextCode: string = undefined as any;
        this.abreCuentasService.setinfoInferredIncomes(res.body);
        if (!res.status || res.status === 500) {
          this.navigationService.navigateToGeneralInformation('500');
        } else if (res.status !== 200) {
          const codigo = res.body.codigo;
          switch (codigo) {
            case '422-06':
            case '422-07':
              if (this.selectedOccupation.id === 3 || this.selectedOccupation.id === 4) {
                nextCode = this.redirecttoOccupationflow();
                return;
              }
              this.navigationService.navigateToGeneralInformation('106');
              this.navigationService.pageLoadTag('Error ocupacion', ['', '', 'pv471']);
              return;
            case '400':
            default:
              this.navigationService.navigateToGeneralInformation('500');
              return;
          }
        } else if (res.status === 200) {
          if ((this.abreCuentasService.getProspectResponse() !== undefined && this.abreCuentasService.getProspectResponse().client) &&
            (this.validationHelperService.validateMailPhone() !== undefined && !this.validationHelperService.validateMailPhone())) {
            this.navigationService.navigateToGeneralInformation('512');
          } else {
            try {
              nextCode = this.redirecttoOccupationflow();
            } catch (error) {
              this.navigationService.navigateToGeneralInformation('102');
            }
            this.navigationService.nextStep(nextCode);
          }
        }
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  redirecttoOccupationflow() {
    let nextCode: string = undefined as any;
    if (+this.selectedOccupation.id > 2) {
      nextCode = '200';
    } else if (+this.selectedOccupation.id === 1) {
      nextCode = '201';
    } else if (+this.selectedOccupation.id === 2) {
      nextCode = '202';
    }
    if (this.abreCuentasService.getCustomerData()) {
      const configClient = this.parametersService.getSetting(OpEnum.CONFIG_CLIENT_EXIST);
      const nowDate = new Date();
      const lastUpdateDate = new Date();
      lastUpdateDate.setTime(this.abreCuentasService.getCustomerData().basic.last_update_date);
      lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
      nextCode = lastUpdateDate.getTime() < nowDate.getTime() ? '200' : '201';
      if (this.abreCuentasService.getCustomerData().basic.profession !== this.selectedOccupation.name) {
        nextCode = '200';
      }
      if (!this.validationHelperService.isValidExistingClient()) {
        nextCode = '200';
      }
    }
    return nextCode;
  }

  /* ------------------ Taggeo ------------------ */

  sendBackButtonEvent(): void {
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv4E1setData.pv4E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv4E1setData.pv4E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv4E1setData.pv4E1transactionName.path,
        value: `${EVENT_FA_LD.pv4E1setData.pv4E1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv4E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv4E2setData.pv4E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E2transactionName.path,
        value: `${EVENT_FA_LD.pv4E2setData.pv4E2transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E3clientElegibility.path,
        value: this.selectedOccupation.name,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv4E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

}
